/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for reading a tutorial tag.
 * @export
 * @interface TutorialTagRead
 */
export interface TutorialTagRead {
    /**
     * 
     * @type {string}
     * @memberof TutorialTagRead
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TutorialTagRead
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TutorialTagRead
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof TutorialTagRead
     */
    created_at: Date;
}

/**
 * Check if a given object implements the TutorialTagRead interface.
 */
export function instanceOfTutorialTagRead(value: object): value is TutorialTagRead {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    return true;
}

export function TutorialTagReadFromJSON(json: any): TutorialTagRead {
    return TutorialTagReadFromJSONTyped(json, false);
}

export function TutorialTagReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): TutorialTagRead {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'id': json['id'],
        'created_at': (new Date(json['created_at'])),
    };
}

export function TutorialTagReadToJSON(json: any): TutorialTagRead {
    return TutorialTagReadToJSONTyped(json, false);
}

export function TutorialTagReadToJSONTyped(value?: TutorialTagRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'id': value['id'],
        'created_at': ((value['created_at']).toISOString()),
    };
}

